// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBar {
    padding-bottom: 10px;
}

.pl40 {
    padding-left: 40px;
}

.mr10 {
    margin-right: 10px;
}

.noMargin {
    margin: 0px!important;
}

.settingslistbox-item {
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/workflow/workflow.version.settings.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".searchBar {\n    padding-bottom: 10px;\n}\n\n.pl40 {\n    padding-left: 40px;\n}\n\n.mr10 {\n    margin-right: 10px;\n}\n\n.noMargin {\n    margin: 0px!important;\n}\n\n.settingslistbox-item {\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
